<template>
  <ul class="c-hitlist__pagination" v-if="showPagination && !isSearching">
    <li class="c-hitlist__pagination_item c-hitlist__pagination_button" v-if="canGoBack"><a href="#" @click.prevent="previous()">&lt;</a></li>
    <li class="c-hitlist__pagination_item" :class="{'c-hitlist__pagination_item--active': currentStep.end == end}" v-for="{start, end, gap} in visibleSteps" :key="start">
      <a v-if="gap">…</a>
      <a v-else href="#" @click.prevent="changePagination(start, end)">{{ start }}-{{ end }}</a>
    </li>
    <li class="c-hitlist__pagination_item c-hitlist__pagination_button" v-if="canGoFwd"><a href="#" @click.prevent="next()">&gt;</a></li>
  </ul>  
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import isEqual from 'lodash/isEqual'

export default {
  name: 'HitlistPagination',
  props: {
    steps: {
      type: Number,
      default: 100
    },
    window: {
      type: Number,
      default: 2
    },
    outerWindow: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapState({
      totalTracks: state => state.hitlist.total,
      firstPosition: state => state.hitlist.firstVisiblePosition
    }),
    ...mapGetters({
      isSearching: 'hitlist/isSearching'
    }),
    allSteps() {
      let steps = [];
      for (
        let start=this.firstPosition, end = Math.floor((start + this.steps) / this.steps) * this.steps;
        start < this.totalTracks;
        start = end, end = Math.min(end + this.steps, this.totalTracks)
      ) {
        steps.push({start, end})
      }

      return steps
    },
    visibleSteps() {
      let visibleSteps = []
      let currentIdx = this.allSteps.findIndex((step) => isEqual(step, this.currentStep))

      for (const [idx, step] of this.allSteps.entries()) {
        if (
          Math.abs(currentIdx - idx) <= this.window || // Inner window
          idx < this.outerWindow || idx >= this.allSteps.length - this.outerWindow
        ) {
          visibleSteps.push(step)
        } else {
          // Add a gap if there is none already
          if (!visibleSteps[visibleSteps.length-1].gap) {
            visibleSteps.push({gap: true})
          }
        }
      }

      return visibleSteps
    },
    currentStep() {
      const currentPagination = this.$store.state.hitlist.pagination
      if (currentPagination !== null) {
        return currentPagination
      } else {
        return this.allSteps[0]
      }
    },

    canGoBack() {
      return !isEqual(this.currentStep, this.allSteps[0])
    },

    canGoFwd() {
      return !isEqual(this.currentStep, this.allSteps[this.allSteps.length-1])
    },

    showPagination() {
      return this.totalTracks > this.steps
    }
  },
  methods: {
    previous() {
      for (let i=0; i<this.allSteps.length; i++) {
        if (isEqual(this.allSteps[i], this.currentStep)) {
          const {start, end} = this.allSteps[i-1]
          this.changePagination(start, end)
          return
        }
      }
    },
    changePagination(start, end) {
      this.$store.dispatch('hitlist/fetchPaginated', {start, end})
    },
    next() {
      for (let i=0; i<this.allSteps.length; i++) {
        if (isEqual(this.allSteps[i], this.currentStep)) {
          const {start, end} = this.allSteps[i+1]
          this.changePagination(start, end)
          return
        }
      }
    }
  }
}
</script>

<style>

</style>